
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Phase I: Lockerung`}</h3>
    <p>{`Die `}<strong parentName="p">{`Supermärkte`}</strong>{` und die `}<strong parentName="p">{`Badis`}</strong>{` sind wieder offen, die `}<strong parentName="p">{`Grossraumbüros`}</strong>{`
werden wieder dichter belegt, und immer mehr Personen nutzen den `}<strong parentName="p">{`ÖV`}</strong>{`. Trotz
Social Distancing und Einhaltung der Hygieneregeln kommt es wieder zu `}<strong parentName="p">{`neuen
Infektionen`}</strong>{`, denn das Coronavirus ist trotz tiefer Fallzahlen immer noch
präsent.`}</p>
    <p>{`Es ist `}<strong parentName="p">{`Montag`}</strong>{`, der 29. Juni: Eine herrliche Woche im Sommer! Sie verlassen
Ihr `}<strong parentName="p">{`Zuhause`}</strong>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;